import { render, staticRenderFns } from "./LayoutSection.vue?vue&type=template&id=21f31da6&scoped=true&"
import script from "./LayoutSection.vue?vue&type=script&lang=ts&"
export * from "./LayoutSection.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutSection.vue?vue&type=style&index=0&id=21f31da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f31da6",
  null
  
)

export default component.exports